var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.5 115C89.2564 115 115 89.2564 115 57.5C115 25.7436 89.2564 0 57.5 0C25.7436 0 0 25.7436 0 57.5C0 89.2564 25.7436 115 57.5 115ZM77.4999 47.5003C77.4999 59.9267 68.5456 70.0003 57.4999 70.0003C46.4542 70.0003 37.4999 59.9267 37.4999 47.5003C37.4999 35.0739 46.4542 25.0003 57.4999 25.0003C68.5456 25.0003 77.4999 35.0739 77.4999 47.5003ZM97.9658 95.4852C87.8414 106.267 73.4572 113.001 57.5002 113.001C41.5433 113.001 27.1593 106.267 17.035 95.4857C25.9656 82.745 40.7604 74.4154 57.5006 74.4154C74.2406 74.4154 89.0351 82.7448 97.9658 95.4852Z",
    fill: "#121622",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfile);
export default __webpack_public_path__ + "static/media/icon_profile.8a97f361cad52cfced5f5a1ceb103955.svg";
export { ForwardRef as ReactComponent };